/* eslint-disable import/order */
import { SidebarIdGlobalIssuesSettings } from '@jira/navigation-apps__constants/src/SidebarIdGlobalIssuesSettings.tsx';
import { legacyPageEntrypoint } from '@jira/router-routes__legacy-page-entrypoint/src/legacyPageEntrypoint.entrypoint.tsx';
import { createPageEntryPoint } from '@jira/platform__routing-create-route-entry-point/src/index.tsx';
import { globalSettingsLayout } from '@jira/platform__layouts-global-settings-layout/src/index.tsx';
import { createLegacyEntry } from '@jira/platform__routing-route-entry/src/createLegacyEntry.tsx';
import { navigationSidebarGlobalResource } from '@jira/router-resources__navigation-sidebar-global/src/navigationSidebarGlobalResource.tsx';
import { globalSettingsIssuesSecurityLevelAddRoute } from '@jira/router-routes__legacy-global-settings-issues-security-level-add-routes/src/globalSettingsIssuesSecurityLevelAddRoute.tsx';
import type { JiraLegacyRoute } from '@jira/platform__routing-route-types/src/JiraLegacyRoute.tsx';
import type { RouteResources } from '@atlassian/react-resource-router';

const pageEntryPoint = createPageEntryPoint({
	main: legacyPageEntrypoint,
});

export const globalSettingsIssuesSecurityLevelAddRouteEntry: JiraLegacyRoute<RouteResources> =
	createLegacyEntry(globalSettingsIssuesSecurityLevelAddRoute, () => ({
		layout: globalSettingsLayout,
		resources: [navigationSidebarGlobalResource],

		navigation: {
			sidebarId: SidebarIdGlobalIssuesSettings,
		},

		entryPoint: () => pageEntryPoint,
	}));
